import { render } from "./CustomAvatarCropper.vue?vue&type=template&id=68b9a146"
import script from "./CustomAvatarCropper.vue?vue&type=script&lang=js"
export * from "./CustomAvatarCropper.vue?vue&type=script&lang=js"

import "./CustomAvatarCropper.vue?vue&type=style&index=0&id=68b9a146&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__